import { Tab, TabIndicator, TabList, TabPanel, TabPanels, Tabs, Text } from "@chakra-ui/react";
import { useState } from "react";

import { ColumnTitle } from "@components/ColumnTitle/ColumnTitle";
import { PageShellWithThreeColumns } from "@components/PageShellWithThreeColumns/PageShellWithThreeColumns";
import { AccountTab } from "@containers/userProfile/AccountTab";
import { ConsumptionsTab } from "@containers/userProfile/ConsumptionsTab";
import { SettingsTab } from "@containers/userProfile/SettingsTab";
import { useAuthContext } from "@/hooks/useAuthContext";
import { $g1Color } from "@/theme/G1Style";

import { SubscriptionTab } from "./SubscriptionTab";

export const UserProfileView = () => {
    const { connectedUser } = useAuthContext();
    const [hiddenSubscriptionTab, setHiddenSubscriptionTab] = useState(true);

    const updateUserProfileView = () => {
        setHiddenSubscriptionTab(false);
    }

    return (
        <PageShellWithThreeColumns
            centralContent={
                <>
                    <ColumnTitle color={$g1Color('global.write')}>
                        <Text>Votre compte</Text>
                    </ColumnTitle>
                    <Tabs isFitted>
                        <TabList color={$g1Color('global.tabs.write')} backgroundColor={$g1Color('global.tabs.bg')}>
                            <Tab fontWeight="semibold">Compte</Tab>
                            <Tab fontWeight="semibold" hidden={hiddenSubscriptionTab}>Abonnement</Tab>
                            <Tab fontWeight="semibold" hidden={hiddenSubscriptionTab}>Mes collaborateurs</Tab>
                            <Tab fontWeight="semibold">Mes consommations</Tab>
                            <Tab fontWeight="semibold">Réglages</Tab>
                        </TabList>
                        <TabIndicator color={$g1Color('global.tabs.indicator.write')} backgroundColor={$g1Color('global.tabs.indicator.bg')} />
                        <TabPanels>
                            <TabPanel>
                                <AccountTab updateUserProfileView={updateUserProfileView} />
                            </TabPanel>
                            <TabPanel hidden={hiddenSubscriptionTab}>
                                <SubscriptionTab connectedUser={connectedUser} pricePerExtraUser={60} />
                            </TabPanel>
                            <TabPanel hidden={hiddenSubscriptionTab}></TabPanel>
                            <TabPanel>
                                <ConsumptionsTab />
                            </TabPanel>
                            <TabPanel>
                                <SettingsTab />
                            </TabPanel>
                        </TabPanels>
                    </Tabs>
                </>
            }
            isOpen={false}
        />
    ) ;
};
